(function ($) {
    $.fn.extend({
        vinnyselect: function (option) {
            let isProgrammaticChange = false;

            $.fn.buildSelect = function (index) {
                let thisSelect = $(this),
                    id = 'vinnyselect-'+ index,
                    label = thisSelect.prev('label'),
                    labelledby = label.attr('for') + 'Label',
                    controls = thisSelect.attr('aria-controls'),
                    options = thisSelect.getOptions(controls, thisSelect.val()),
                    first = thisSelect.find('option').first().text(),
                    select = $(`<div class="vinnyselect"></div>`),
                    current = $(`<button type="button" class="current" role="combobox" aria-controls="${id}" aria-haspopup="listbox" aria-expanded="false" aria-labelledby="${labelledby}">${first}</button>`),
                    dropdown = $(`<ul id="${id}" class="options" role="listbox" aria-labelledby="${labelledby}" tabindex="-1">${options}</ul>`);

                label.attr('id', label.attr('for') + 'Label');

                if (thisSelect.attr('data-default')) {
                    thisSelect.val(thisSelect.attr('data-default'));
                }

                if (thisSelect.val()) {
                    current.text(thisSelect.find('option[value="'+ thisSelect.val() +'"]').text());
                }

                thisSelect.addClass('vinnyselect-hidden');
                select.append(current);
                select.append(dropdown);
                thisSelect.after(select);
                thisSelect.hide();
            };

            $.fn.getOptions = function(controls, thisValue){
                let options = '';

                $(this).find('option').each(function(){
                    let option = $(this),
                        value = option.attr('value'),
                        text = $(`<li class="option" role="option" data-value="${value}" aria-selected="false" tabindex="-1">${$(this).text()}</li>`);

                    if (value.length === 0) {
                        return;
                    }

                    if (!controls || controls.length > 0) {
                        text = text.attr('aria-controls', controls);
                    }

                    if (thisValue === value) {
                        text.attr('aria-selected', 'true');
                    }

                    if (option.attr('data-color')) {
                        let color = `<span class="option-color" style="background-color: ${option.attr('data-color')};"></span>`

                        text.prepend(color);
                    }

                    options += text.prop('outerHTML');
                });

                return options;
            }

            // init
            $(this).each(function(index){
                let vinnyselect = $(this);

                if (!vinnyselect.hasClass('vinnyselect-hidden')) {
                    vinnyselect.buildSelect(index);
                }
            })

            if (option !== 'init') {
                initEvents();
            }

            function openSelect(select) {
                closeSelect($('.vinnyselect.open').not(select));

                let current = select.find('.current'),
                    dropdown = select.find('.options'),
                    focus = dropdown.find('.option[aria-selected="true"]');

                if (focus.length === 0) {
                    focus = dropdown.find('.option').first();
                }

                select.addClass('open');
                current.attr('aria-expanded', 'true');
                focus.focus();
                dropdown.attr('tabindex', '0');
                dropdown.find('li').attr('tabindex', '0');
            }

            function closeSelect(select) {
                let current = select.find('.current'),
                    dropdown = select.find('.options');

                select.removeClass('open');
                current.attr('aria-expanded', 'false');
                dropdown.attr('tabindex', '-1');
                dropdown.find('li').attr('tabindex', '-1');
            }

            // events
            function initEvents() {
                // on current click
                $(document).on('click', '.vinnyselect .current', function(){
                    let current = $(this),
                      select = current.closest('.vinnyselect');

                    if (select.hasClass('open')) {
                        closeSelect(select);
                    } else {
                        openSelect(select);
                    }
                });

                // on option click
                $(document).on('click', '.vinnyselect .option', function(){
                    let option = $(this),
                      value = option.data('value'),
                      text = option.text(),
                      select = option.closest('.vinnyselect'),
                      thisSelect = select.prev('select'),
                      current = select.find('.current');

                    current.empty();
                    current.text(text);
                    option.siblings().attr('aria-selected', 'false');
                    option.attr('aria-selected', 'true');
                    thisSelect.val(value);

                    if (option.find('.option-color').length > 0) {
                        option.find('.option-color').clone().prependTo(current);
                    }

                    closeSelect(select);

                    current.focus();

                    if (!isProgrammaticChange) {
                        let event = new Event('change', { bubbles: true });
                        thisSelect[0].dispatchEvent(event);
                    }

                    isProgrammaticChange = false;
                });

                // on current keydown
                $(document).on('keydown', '.vinnyselect .current', function(e) {
                    // if down / up arrow
                    if (e.keyCode === 40 || e.keyCode === 38) {
                        e.preventDefault();
                        let current = $(this),
                          select = current.closest('.vinnyselect'),
                          dropdown = current.next('.options'),
                          options = dropdown.find('.option'),
                          next = options.first();

                        if (e.keyCode === 38) {
                            next = options.last();
                        }

                        if (!select.hasClass('open')) {
                            openSelect(select);
                            return;
                        }

                        next.focus();
                    }
                });

                // on option keydown
                $(document).on('keydown', '.vinnyselect .option', function(e) {
                    // if down / up arrow
                    if (e.keyCode === 40 || e.keyCode === 38) {
                        e.preventDefault();
                        let option = $(this),
                          options = option.parent().children(),
                          index = options.index(option),
                          next = options.eq(index + 1);

                        if (e.keyCode === 38) {
                            next = options.eq(index - 1);
                        }

                        if (index === options.length - 1 && e.keyCode === 40) {
                            next = options.first();
                        }

                        next.focus();
                    }
                });

                // on keydown
                $(document).on('keydown', '.vinnyselect', function(e) {
                    // if escape
                    if (e.keyCode === 27) {
                        e.preventDefault();
                        let select = $(this),
                          current = select.find('.current');

                        closeSelect(select);

                        current.focus();
                    }
                });

                // on click away
                $(document).on('click', function(e){
                    if (!$(e.target).closest('.vinnyselect').length) {
                        closeSelect($('.vinnyselect.open'));
                    }
                });

                // if label clicked
                $(document).on('click', 'label', function(e){
                    let select = $('.current[aria-labelledby="'+ $(this).attr("for") +'"]').closest('.vinnyselect');

                    if (select.length > 0) {
                        e.stopPropagation();
                        e.preventDefault();

                        openSelect(select);

                        select.find('.current').focus();
                    }
                });

                // if select changed
                $('.vinnyselect-hidden').on('change', function(){
                    let thisSelect = $(this);

                    isProgrammaticChange = true;

                    thisSelect.next('.vinnyselect').find('[data-value="'+ thisSelect.val() +'"]').click();
                });
            }
        }
    });
})(jQuery);
